import notify from './notify'
import type {ErrorMessageProps} from './components/ErrorMessage';
import ErrorMessage from './components/ErrorMessage'
import RDS from 'react-dom/server'

export function notifyErrorResponse(props: ErrorMessageProps) {
    notify({
        html: RDS.renderToStaticMarkup(ErrorMessage(props)),
        className: 'error'
    })
}

export function notifyWarningResponse(props: ErrorMessageProps) {
    notify({
        html: RDS.renderToStaticMarkup(ErrorMessage(props)),
        className: 'warning'
    })
}
